import monsole from '@/utils/monsole';
import type { TagKind } from './types';

/** 每个 kind 各自的搜索历史上限 */
export const MAX_SEARCH_HISTORY = 5;

/** 按 kind 分键存储，避免多 kind 之间的读-改-写相互覆盖 */
const STORAGE_KEY_PREFIX = 'tos.record.searchHistory';

function storageKey(kind: TagKind): string {
  return `${STORAGE_KEY_PREFIX}.${kind}`;
}

/** 读取单个 kind 的搜索历史；数据缺失/损坏时回退空数组 */
function loadKind(kind: TagKind): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(storageKey(kind));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((x): x is string => typeof x === 'string')
      .map(x => x.trim())
      .filter(Boolean)
      .slice(0, MAX_SEARCH_HISTORY);
  } catch (e: any) {
    monsole.error('[record] load search history fail', { kind }, e?.message);
    return [];
  }
}

/** 载入全部 kind 的搜索历史（store 初始化时调用一次） */
export function loadSearchHistory(): Record<TagKind, string[]> {
  return { fst: loadKind('fst'), fit: loadKind('fit') };
}

/** 写回单个 kind 的搜索历史 */
export function saveSearchHistory(kind: TagKind, terms: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(storageKey(kind), JSON.stringify(terms));
  } catch (e: any) {
    monsole.error('[record] save search history fail', { kind }, e?.message);
  }
}
